/**
 * How the outcome of adding a member is described to the operator.
 *
 * Kept separate from the page so it can be asserted directly: whether an email
 * was actually sent is the part that gets read as a promise, and the operator
 * acts on it -- telling somebody to watch for mail that was never sent sends
 * them looking through their spam folder for nothing.
 */
export function onboardedMessage({
  name,
  portalInvited,
}: {
  name: string;
  portalInvited: boolean;
}): string {
  return portalInvited
    ? `${name} was added and invited`
    : `${name} was added — they already have a Roger login, so no invitation was sent`;
}
